import { ThemeColors } from '@fairfashion/design-system'

export const colors: ThemeColors[] = [
  'gray_blue',
  'purple',
  'orange',
  'light_blue',
  'pink',
  'light_purple',
]
